import {D3SeatingChart} from './D3SeatingChart';
import {ShowBehavior} from './showBehavior.enum';
import {event, select, selectAll} from "d3-selection";
import {SeatClickedEvent, SeatMouseOutEvent, SeatMouseOverEvent} from "./events/SeatEvent";
import {Seat, SeatStatus} from "./models/Seat";
import {BlockClickedEvent} from "./events/BlockClickedEvent";
import {IBasicController} from "./IBasicController";
import {IEventListener} from "./IEventListener";

export class SeatingChartWrapperConfig {
    useTooltips: boolean = true;
    tooltipAttribute: string = 'code';
    tooltipDelay: number = 250;
    tooltipCssClass: string = 'seat-tooltip';
}

export abstract class SeatingChartController implements IBasicController {
    private seatingChart!: D3SeatingChart;
    private blockSelect: boolean = false;
    private isPlanEnabled = true;
    private tooltipsEnabled = true;
    private seats: Seat[] = [];

    private tooltip: any;

    private eventListener: IEventListener | null = null;

    private svgElement: HTMLImageElement | null = null;
    private containerElement: HTMLDivElement | null = null;
    private config: SeatingChartWrapperConfig | null = new SeatingChartWrapperConfig();

    // static attachByIds(svgElementId: string, containerElementId: string, config: SeatingChartWrapperConfig = new SeatingChartWrapperConfig()): SeatingChartController {
    //     let svg = document.getElementById('seatplan_svg') as HTMLImageElement;
    //     let div = document.getElementById("seatplan_div") as HTMLDivElement;
    //
    //     return SeatingChartController.attach(svg, div);
    // }
    //
    // static attach(svgElement: HTMLImageElement, containerElement: HTMLDivElement, config: SeatingChartWrapperConfig = new SeatingChartWrapperConfig()): SeatingChartController {
    //     return new SeatingChartController(svgElement, containerElement);
    // }


    // static attach<T extends SeatingChartController>(type: new (svgElement: HTMLImageElement, containerElement: HTMLDivElement) => T, svgElement: HTMLImageElement, containerElement: HTMLDivElement) {
    //     return new type(svgElement, containerElement);
    // }
    //
    // static attachByIds<T extends SeatingChartController>(type: new (svgElement: HTMLImageElement, containerElement: HTMLDivElement) => T, svgElement: string, containerElement: string) {
    //     let svg = document.getElementById('seatplan_svg') as HTMLImageElement;
    //     let div = document.getElementById("seatplan_div") as HTMLDivElement;
    //     return new type(svg, div);
    // }

    public AddEventListener(app: IEventListener) {
        this.eventListener = app;
    }


    private async SendEvent(event: string, object: any): Promise<boolean> {
        if (this.eventListener) {
            return await this.eventListener.handle(event, object);
        }

        console.log("No eventlistener defined for the seating map events.")
        return false;
    }

    public constructor() {
    }

    // public constructor(
    //     private svgElement: HTMLImageElement,
    //     private containerElement: HTMLDivElement,
    //     private config: SeatingChartWrapperConfig = new SeatingChartWrapperConfig()
    // ) 
    public init(svgElement: HTMLImageElement,
                containerElement: HTMLDivElement,
                config: SeatingChartWrapperConfig = new SeatingChartWrapperConfig()) {
        this.svgElement = svgElement;
        this.containerElement = containerElement;
        this.config = config;
        this.seatingChart = D3SeatingChart.attach(svgElement, {
            allowManualSelection: false,
            showBehavior: ShowBehavior.All
        });
        SeatingChartController.redrawWrapper(this);

        //this.seatingChart.disablePlan();

        this.blockSelect = false;
        this.bindEvents();
        this.drawDisabledCrosses();
        this.tooltipsEnabled = true;
        let s = this;

        this.tooltip = select("body").append("div")
            .attr("class", this.config.tooltipCssClass)
            .style("opacity", 0);

        window.addEventListener("resize", function () {
            SeatingChartController.redrawWrapper(s)
        });
        this.seatingChart.registerSeatClickedListener(e => this.onSeatClicked(e))
        this.seatingChart.registerBlockClickedListener(e => this.onZoomLevelClicked(e))
        this.seatingChart.registerSeatMouseOverListener(e => this.onSeatMouseOver(e))
        this.seatingChart.registerSeatMouseOutListener(e => this.onSeatMouseOut(e))
        let se = this.seats;
        this.seatingChart.selectElements("[seat]").nodes().forEach((d, i) => {
            se.push(new Seat(<SVGElement>d))
        });

        // this.seats.find(s => s.code == "1A01")?.AddTooltipInfo("<p>Het eerste zitje<br/>Test</p>");
        // this.seats.find(s => s.code == "1A02")?.AddTooltipInfo("Het tweede zitje");
    }

    protected async onSeatClicked(e: SeatClickedEvent) {
        const seatCode = e.ele.getAttribute("code");
        if (seatCode) {
            let seat = this.seats.find(s => s.code == seatCode);
            if (seat && seat.isEnabled) {
                seat.Disable();
                if (seat.HasStatus(SeatStatus.Free)) {
                    seat.SetStatus(SeatStatus.Locked);
                    if (!await this.selectSeatBySeatCode(seatCode)) {
                        await this.freeSeatBySeatCode(seatCode, false)
                        
                    }
                    //await this.afterSeatSelectedBySeatClick(seat,  () => this.freeSeatBySeatCode(seatCode));


                } else if (seat.HasStatus(SeatStatus.Selected)) {
                    seat.SetStatus(SeatStatus.Locked);
                    if (!await this.freeSeatBySeatCode(seatCode)) {
                        await this.selectSeatBySeatCode(seatCode, false)
                    }
                    //await this.afterSeatFreedBySeatClick(seat,  () => this.selectSeatBySeatCode(seatCode));
                }
                seat.Enable();
            }
        }
    }

    private async afterSeatSelectedBySeatClick(seat: Seat, onError: () => void) {
        try {
            const api = 'https://jsonplaceholder.typicode.com/posts/1'
            const response = await fetch(api);
            const data = await response.json();
            if (!response.ok) {
                onError();
            }


        } catch (error) {
            onError();
        }
    }

    private async afterSeatFreedBySeatClick(seat: Seat, onError: () => void) {
        try {
            const api = 'https://jsonplaceholder.typicode.com/osts/1'
            const response = await fetch(api);
            const data = await response.json();
            if (!response.ok) {
                onError();
            }
            console.log(data);
            await this.SendEvent('seatfreed', {seatCode: seat.code});
        } catch (error) {
            onError();
        }
    }

    protected async onSeatMouseOver(e: SeatMouseOverEvent) {
        let mouseEvent = <MouseEvent>event
        if (!mouseEvent || mouseEvent.buttons != 1) {
            if (this.tooltipsEnabled) {
                this.showTooltip(e);
            }
        }
        // } else {
        //     console.log("hover");
        //     const seatCode = e.ele.getAttribute("code");
        //     if (seatCode) {
        //         let seat = this.seats.find(s => s.code == seatCode);
        //         if (seat && seat.isEnabled) {
        //             if (seat.HasStatus(SeatStatus.Free)) {
        //                 if (!await this.selectSeatBySeatCode(seatCode)) {
        //                     await this.freeSeatBySeatCode(seatCode, false)
        //                 }
        //                 //await this.afterSeatSelectedBySeatClick(seat,  () => this.freeSeatBySeatCode(seatCode));
        //
        //
        //             } else if (seat.HasStatus(SeatStatus.Selected)) {
        //                 if (!await this.freeSeatBySeatCode(seatCode)) {
        //                     await this.selectSeatBySeatCode(seatCode, false)
        //                 }
        //                 //await this.afterSeatFreedBySeatClick(seat,  () => this.selectSeatBySeatCode(seatCode));
        //             }
        //         }
        //     }
        // }


    }

    protected onSeatMouseOut(e: SeatMouseOutEvent) {
        if (this.tooltipsEnabled) {
            this.hideTooltip(e);
        }
    }

    protected getTooltipData(e: SVGElement) {
        let seatCode = e.getAttribute(this.config!.tooltipAttribute);
        if (seatCode == null) {
            return;
        }

        let seat = this.seats.find(s => s.code == seatCode);
        if (seat?.tooltipInfo) {
            seatCode = seat.tooltipInfo;
        }

        return seatCode;
    }

    protected styleTooltip(text: string) {
        this.tooltip
            .transition()
            .delay(this.config!.tooltipDelay)
            .duration(50)
            .style("opacity", 1);

        this.tooltip.html(text)
            .style("left", (event.pageX + 10) + "px")
            .style("top", (event.pageY - 15) + "px");
    }

    public showTooltip(e: SeatMouseOverEvent) {
        const text = this.getTooltipData(e.ele);
        if (text) {
            this.styleTooltip(text)
        }
    }

    public hideTooltip(e: SeatMouseOutEvent) {
        this.tooltip.transition()
            .duration(50)
            .style("opacity", 0);
    }

    static redrawWrapper(wrapper: SeatingChartController) {
        const originalHeight = 843;
        const originalWidth = 708;

        // Extract the width and height that was computed by CSS.
        const width = wrapper.getContainerElement().clientWidth;
        const height = wrapper.getContainerElement().clientWidth * (originalHeight / originalWidth);

        // Use the extracted size to set the size of an SVG element.
        wrapper.getSvgElement().setAttribute("width", width.toString());
        wrapper.getSvgElement().setAttribute("height", height.toString());
        wrapper.getSeatingChart().refresh();
    }

    private getSeatingChart() {
        return this.seatingChart;
    }

    private getSvgElement(): HTMLImageElement {
        return this.svgElement!;
    }

    public getContainerElement(): HTMLDivElement {
        return this.containerElement!
    }

    public goToBoard() {
        this.seatingChart.goToBoard();
    }

    public goBack() {
        this.seatingChart.goBack();
    }

    public canGoBack(): boolean {
        return this.seatingChart.canGoBack();
    }

    public setBlockSelect() {
        this.blockSelect = true;
        this.seatingChart.goToBoard();
    }

    public setSeatSelect() {
        this.blockSelect = false;
    }

    public drawDisabledCrosses() {

        let crosspaths = selectAll('path[cross]');
        let removed = crosspaths.remove();

        let seatingAreas = selectAll("g[seating-area]").each((darea, iarea, garea) => {
            let disabledElements = select(garea[iarea]).selectAll("[cross]").each((dseat, iseat, gseat) => {

                let seat = <SVGElement>gseat[iseat];
                let x1 = Number.parseInt(seat.getAttribute("x")!) + 1;
                let y1 = Number.parseInt(seat.getAttribute("y")!) + 1;
                let height = Number.parseInt(seat.getAttribute("height")!) - 2;
                let width = Number.parseInt(seat.getAttribute("width")!) - 2;

                let color = seat.getAttribute("cross")!;

                let x2 = x1 + width;
                let y2 = y1 + height;

                try {
                    select(garea[iarea]).append("path")
                        .attr("d", `M ${x1} ${y1} L ${x2} ${y2} M ${x2} ${y1} L ${x1} ${y2}`)
                        .attr("stroke", color)
                        .attr('stroke-width', 1)
                        .attr('cross', '');
                } catch (e) {
                    debugger;
                }

            });
        })
    }

    // get vueAppGateway(): ISeatingChartGateway | null { return this.appGateway; }
    //
    // set vueAppGateway(value: ISeatingChartGateway | null) { this.appGateway = value; }


    private bindEvents() {

    }

    public addSeatCross(codes: string[], color: string): void {
        for (let code of codes) {
            var ele = <SVGElement>this.seatingChart.selectElement('[seat][code="' + code + '"]').node();
            ele.setAttribute('cross', color);
        }
        this.drawDisabledCrosses();
    }


    public updateSeatsWithCssClass(codes: string[], cssClass: string): void {
        for (let code of codes) {
            var ele = <SVGElement>this.seatingChart.selectElement('[seat][code="' + code + '"]').node();
            if (ele){
                ele.classList.add(cssClass);    
            }
            
        }
    }

    public updateSeatsWithStyles(codes: string[], styles: Map<string, string>) {
        for (let code of codes) {
            let ele = this.seatingChart.selectElement('[seat][code="' + code + '"]');
            if (ele){
                styles.forEach((value, key) => {
                    ele.style(key, value);
                });    
            }
            
        }
    }

    public lockSeatBySeatCode(seatCode: string) {
        let seat = this.getSeatBySeatCode(seatCode);
        if (seat) {
            this.lockSeat(seat);
        }
    }

    public async selectSeatBySeatCode(seatCode: string, triggerEvents: boolean = true): Promise<boolean> {
        let seat = this.getSeatBySeatCode(seatCode);
        if (seat) {
            return await this.selectSeat(seat,undefined, triggerEvents);
        }
        return false;
    }


    public async freeSeatBySeatCode(seatCode: string, triggerEvents: boolean = true): Promise<boolean> {
        let seat = this.getSeatBySeatCode(seatCode);
        if (seat) {
            return this.freeSeat(seat, triggerEvents);
        }

        return false;
    }

    public lockSeat(seat: Seat, statusInfo?: string) {
        if (seat.HasStatus(SeatStatus.Locked, statusInfo))
            return;

        seat.SetStatus(SeatStatus.Locked, statusInfo);
        let ele = <SVGElement>this.seatingChart.selectElement('[seat][code="' + seat.code + '"]').node();
        ele.setAttribute('locked', statusInfo ?? "");

        if (ele.hasAttribute('selected')) {
            ele.removeAttribute('selected');
        }
    }

    public async selectSeat(seat: Seat, statusInfo?: string, triggerEvent: boolean = true): Promise<boolean> {
        if (seat.HasStatus(SeatStatus.Selected, statusInfo))
            return false;

        seat.SetStatus(SeatStatus.Selected, statusInfo);
        let ele = <SVGElement>this.seatingChart.selectElement('[seat][code="' + seat.code + '"]').node();
        ele.setAttribute('selected', statusInfo ?? "");

        if (ele.hasAttribute('locked')) {
            ele.removeAttribute('locked');
        }

        if (triggerEvent) {
            return await this.SendEvent('seatselectedEvent', {seatCode: seat.code});
        }

        return true;

    }

    public async freeSeat(seat: Seat, triggerEvent: boolean = true): Promise<boolean> {
        if (seat.HasStatus(SeatStatus.Free))
            return false;

        seat.SetStatus(SeatStatus.Free);

        let ele = <SVGElement>this.seatingChart.selectElement('[seat][code="' + seat.code + '"]').node();
        if (ele.hasAttribute('locked')) {
            ele.removeAttribute('locked');
        }

        if (ele.hasAttribute('selected')) {
            ele.removeAttribute('selected');
        }

        if (triggerEvent) {
            return await this.SendEvent('seatFreedEvent', {seatCode: seat.code});
        }

        return true;
    }


    public getSeatBySeatCode(seatcode: string): Seat | undefined {
        return this.seats.find(s => s.code === seatcode);
    }

    public selectAllFree() {
        this.seats.forEach(s => {
            if (s.HasStatus(SeatStatus.Free)) {
                this.selectSeat(s);
            }
        });
    }

    public freeAllSelected() {
        this.seats.forEach(s => {
            if (s.HasStatus(SeatStatus.Selected)) {
                this.freeSeat(s);
            }
        });
    }

    public zoom(selection: any, animate: boolean = true) {
        this.seatingChart.zoom(selection, animate);
    }

    public disable() {
        this.seatingChart.selectElements('[zoom-target]').selectAll('[seat]').attr('disabled', '');
    }

    public disablePlan() {
        this.isPlanEnabled = false;
    }

    public enable() {
        let ele = this.seatingChart.selectElements('[zoom-target]').attr("disabled", '');
    }

    public enablePlan() {
        this.isPlanEnabled = true;
    }

    private onZoomLevelClicked(e: BlockClickedEvent) {

        let ele = e.ele;
        //let ele = d3.event.srcElement || d3.event.target;
        let expose = ele.getAttribute('zoom-control');

        if (expose) {
            let zoomElement = this.seatingChart.selectElement(`[zoom-target="${expose}"]`);
            if (!this.isPlanEnabled || zoomElement.attr("disabled")) {
                return;
            }

            if (this.blockSelect) {
                this.selectSeatsInBlock(zoomElement);
            } else {
                this.seatingChart.zoom(zoomElement)
            }
        }
    }

    private selectSeatsInBlock(zoomElement: any) {
        let svgElementsInBlock = <SVGElement[]>zoomElement.selectAll('[seat]').nodes();
        let seatsInBlock = new Array<Seat>();
        for (const svgElement of svgElementsInBlock) {
            let seat = this.seats.find(s => s.code === svgElement.getAttribute('code'));

            if (seat) {
                seatsInBlock.push(seat);
            }
        }

        let freeSeats = seatsInBlock.filter(s => s.HasStatus(SeatStatus.Free));
        if (freeSeats.length > 0) {
            for (const seat of freeSeats) {
                this.selectSeat(seat);
            }
        } else {
            let selectedSeats = seatsInBlock.filter(s => s.HasStatus(SeatStatus.Selected))
            if (selectedSeats.length > 0) {
                for (const seat of selectedSeats) {
                    this.freeSeat(seat);
                }
            }
        }
    }
}

declare global {
    interface Window {
        eventBus: any;
        app: any;
    }
}

// let seatingChartWrapper = SeatingChartController.attachByIds('seatplan_svg', 'seatplan_div');

// (<any>window).vm = {};
// (<any>window).vm.map = seatingChartWrapper;
//seatingChartWrapper.disable();

// OUTSIDE -> Vue

// Interact with vuejs application from outside
// e.g.: seat is clicke => it is added to a list
// https://jsfiddle.net/xmqgnbu3/1/ --> https://stackoverflow.com/questions/33682651/call-a-vue-js-component-method-from-outside-the-component

// VUE -> Outside
// https://timonweb.com/posts/firing-vuejs-events-into-outer-space-or-how-to-make-my-legacy-js-code-react-on-vue-js-events/








